const { getGameType } = require('./getGameType');
const { getHitResult, tempSpaceChar } = require('./getHitResult');

// Used in the end query string
const SEP = ' AND ';
const COLON = ' = ';
const COMMA = ',';

// A Class that can have values set dynamically
// and a query returned once all values have been passed.
// Letting the class generate the output allows for consistent
// url param ordering and better cacheing.
class FilmRoomQuery {
  constructor() {
    // Set initial arrays for population by user
    this.batterId = [];
    this.battingTeamId = [];
    this.pitcherId = [];
    this.pitchingTeamId  = [];
    this.hitResult = [];
    this.gameType = [];
    this.season = [];
    this.gamePk = [];
    this.date = undefined;
    this.orderBy = 'Timestamp';
    this.orderDir = 'DESC';

    this.baseUrl = 'https://www.mlb.com/video/search';
  };

  // Returns the end query to use
  get query() {
    let params = '';
    // Batters
    if (this.batterId.length) params += this.buildKeyValPair('BatterId', this.buildArr(this.batterId), !!params);
    // Batting Teams
    if (this.battingTeamId.length) params += this.buildKeyValPair('BattingTeamId', this.buildArr(this.battingTeamId), !!params);
    // Pitchers
    if (this.pitcherId.length) params += this.buildKeyValPair('PitcherId', this.buildArr(this.pitcherId), !!params);
    // Pitching Teams
    if (this.pitchingTeamId.length) params += this.buildKeyValPair('PitchingTeamId', this.buildArr(this.pitchingTeamId), !!params);
    // Hit Results
    if (this.hitResult.length) params += this.buildKeyValPair('HitResult', this.buildArr(this.hitResult), !!params);
    // Game Types
    if (this.gameType.length) params += this.buildKeyValPair('GameType', this.buildArr(this.gameType), !!params);
    // Seasons
    if (this.season.length) params += this.buildKeyValPair('Season', this.buildArr(this.season), !!params);
    // Date / Date Range
    if (this.date) params += this.buildKeyValPair('Date', this.date, !!params);
    // GamePk
    if (this.gamePk.length) params += this.buildKeyValPair('gamePk', this.buildArr(this.gamePk), !!params);
    // Order
    params += ` Order By ${this.orderBy} ${this.orderDir}`;
    // Replace colons and commas with desired codes
    // Manually re-add spaces where we want them in Film Room output
    return `${this.baseUrl}${params ? '?q=' : ''}${encodeURIComponent(params).split('%20').join('+').split(tempSpaceChar).join('%20')}`;
  };

  buildArr(arr, quoteVals) {
    let arrStr = '[';
    let itemSet = false;
    for (const i in arr) {
      const item = arr[i];
      let itemStr = quoteVals ? `${item}"` : item;
      if (itemSet) {
        itemStr = `${COMMA}${itemStr}`;
      } else {
        itemSet = true;
      }
      arrStr += itemStr;
    }
    return arrStr += ']';
  };

  buildKeyValPair(key, val, needsSep) {
    return `${needsSep ? SEP : ''}${key}${COLON}${val}`
  };

  setBaseUrl(newBase = '') {
    this.baseUrl = newBase;
    return this;
  };

  // The URL format supports multiple:
  // - BatterIds
  // - BattingTeamIds
  // - PitcherIds
  // - PitchingTeamIds
  // - HitResults
  // - GameTypes
  // - Seasons
  // But we're using a singular:
  // - Date / DateRange
  // - Ordering
  setBatterId(val) {
    if (val) this.batterId.push(val);
    return this;
  };
  setBattingTeamId(val) {
    if (val) this.battingTeamId.push(val);
    return this;
  };
  setPitcherId(val) {
    if (val) this.pitcherId.push(val);
    return this;
  };
  setPitchingTeamId(val) {
    if (val) this.pitchingTeamId.push(val);
    return this;
  };
  setHitResult(val) {
    if (val) {
      const calculatedHitResult = getHitResult(val);
      if (calculatedHitResult) {
        const splitHitResults = calculatedHitResult.split(',');
        for (let hr in splitHitResults) {
          this.hitResult.push(splitHitResults[hr]);
        }
      }
    };
    return this;
  };
  setGameType(val) {
    if (val) {
      const calculatedGameType = getGameType(val);
      if (calculatedGameType) {
        const splitGameTypes = calculatedGameType.split(',');
        for (let gt in splitGameTypes) {
          this.gameType.push(splitGameTypes[gt]);
        }
      }
    };
    return this;
  };
  setSeason(val) {
    if (val) this.season.push(val);
    return this;
  };
  setGamePk(val) {
    if (val) this.gamePk.push(val);
    return this;
  };
  setDate(startDate, endDate) {
    if (startDate && endDate) {
      this.date = `{{ "${startDate}"${COMMA} "${endDate}" }}`;
    } else if (startDate) {
      this.date = `["${startDate}"]`;
    }
    return this;
  };
  setOrderBy(val) {
    if (val) this.orderBy = val;
    return this;
  };
  setOrderDir(val) {
    if (val) this.orderDir = val;
    return this;
  };
};

module.exports = FilmRoomQuery;
